{
  "EMOJI": {
    "PLACEHOLDER": "Emoji keresése",
    "NOT_FOUND": "Nem található emoji",
    "REMOVE": "Eltávolítás"
  }
}
